import { supabase } from '../lib/supabase';

export const cardService = {
  getCard: async (id, userId) => {
    const { data, error } = await supabase
      .from('cards')
      .select('*')
      .eq('id', id)
      .eq('user_id', userId)
      .single();
    
    if (error) throw error;
    return data;
  },

  getLinks: async (cardId) => {
    const { data, error } = await supabase
      .from('card_links')
      .select('*')
      .eq('card_id', cardId)
      .order('display_order', { ascending: true });
      
    if (error) throw error;
    return data || [];
  },

  updateCard: async (id, userId, updates) => {
    const { data, error } = await supabase
      .from('cards')
      .update(updates)
      .eq('id', id)
      .eq('user_id', userId)
      .select()
      .single();
      
    if (error) throw error;
    return data;
  },

  saveLinks: async (cardId, links) => {
    const { error: deleteError } = await supabase
      .from('card_links')
      .delete()
      .eq('card_id', cardId);
      
    if (deleteError) throw deleteError;

    if (links.length > 0) {
      const linksToInsert = links.map((l, index) => ({
        card_id: cardId,
        platform: l.platform || 'custom',
        title: l.title,
        url: l.url,
        is_visible: l.is_visible,
        display_order: index
      }));

      const { error: insertError } = await supabase
        .from('card_links')
        .insert(linksToInsert);
        
      if (insertError) throw insertError;
    }
  },

  checkSlugAvailability: async (slug, excludeCardId) => {
    const { data, error } = await supabase
      .from('cards')
      .select('id')
      .eq('public_slug', slug)
      .neq('id', excludeCardId);
      
    if (error) throw error;
    return data.length === 0;
  },

  // Public Query with strict frontend field selection for security
  getPublicCardBySlug: async (slug) => {
    const { data: card, error: cardError } = await supabase
      .from('cards')
      .select('id, public_slug, full_name, pronouns, job_title, company_name, bio, profile_image_url, cover_image_url, email, phone, website, location, template_id, contact_visibility, button_style, accent_color, actions_config, appearance')
      .eq('public_slug', slug)
      .eq('status', 'published')
      .single();

    if (cardError) throw cardError;

    const { data: links, error: linksError } = await supabase
      .from('card_links')
      .select('platform, title, url, is_visible, display_order')
      .eq('card_id', card.id)
      .eq('is_visible', true)
      .order('display_order', { ascending: true });

    if (linksError) throw linksError;

    return { card, links: links || [] };
  }
};